
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"33.427"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.591 20.73l-2.871-1.658a12.981 12.981 0 000-4.731l2.871-1.658a.814.814 0 00.371-.944 16.785 16.785 0 00-3.686-6.375.811.811 0 00-1-.155l-2.871 1.658a12.719 12.719 0 00-4.1-2.366V1.193a.807.807 0 00-.629-.792 16.942 16.942 0 00-7.359 0 .807.807 0 00-.634.789v3.316a13.12 13.12 0 00-4.1 2.366L4.719 5.214a.8.8 0 00-1 .155 16.684 16.684 0 00-3.686 6.375.806.806 0 00.371.944l2.871 1.658a12.982 12.982 0 000 4.731L.404 20.735a.814.814 0 00-.371.944 16.785 16.785 0 003.686 6.375.811.811 0 001 .155l2.871-1.658a12.719 12.719 0 004.1 2.366v3.316a.807.807 0 00.634.789 16.942 16.942 0 007.359 0 .807.807 0 00.633-.789v-3.314a13.12 13.12 0 004.1-2.366l2.871 1.658a.8.8 0 001-.155 16.684 16.684 0 003.686-6.375.832.832 0 00-.382-.951zm-15.595 1.371a5.392 5.392 0 115.392-5.392 5.4 5.4 0 01-5.392 5.392z","fill":"#fff"}})])
          )
        }
      }
    